import VolunteerPage from './VolunteerPage.vue';

export default [
  {
    path: '/volunteer',
    name: 'volunteer',
    component: VolunteerPage,
  },
];
